
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.6667 1H29.3333C36.8812 1 43 7.11878 43 14.6667V29.3333C43 36.8812 36.8812 43 29.3333 43H14.6667C7.11877 43 1 36.8812 1 29.3333V14.6667C1 7.11877 7.11878 1 14.6667 1Z","fill":"black","stroke":"black","stroke-width":"2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20 12C19.2044 12 18.4413 12.3161 17.8787 12.8787C17.3161 13.4413 17 14.2043 17 15V16H14C12.3431 16 11 17.3431 11 19V29C11 30.6569 12.3431 32 14 32H18H26H30C31.6569 32 33 30.6569 33 29V19C33 17.3431 31.6569 16 30 16H27V15C27 14.2043 26.6839 13.4413 26.1213 12.8787C25.5587 12.3161 24.7956 12 24 12H20ZM25 16V15C25 14.7348 24.8946 14.4804 24.7071 14.2929C24.5196 14.1054 24.2652 14 24 14H20C19.7348 14 19.4804 14.1054 19.2929 14.2929C19.1054 14.4804 19 14.7348 19 15V16H25ZM19 18H25V30H19V18ZM17 18H14C13.4477 18 13 18.4477 13 19V29C13 29.5523 13.4477 30 14 30H17V18ZM27 30V18H30C30.5523 18 31 18.4477 31 19V29C31 29.5523 30.5523 30 30 30H27Z","fill":"white"}})])
          )
        }
      }
    